import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { createSlice } from '@reduxjs/toolkit';
import { isEqual } from '../../../utils/object';
var sliceName = 'ACTION_COMMANDS';
var initialState = {
  actions: [],
  actionsLoading: false,
  lastActionExecuted: null,
  promoActionRunning: null
};
var actionCommandsSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    setActionCommand: function setActionCommand(state, action) {
      state.actions = [].concat(_toConsumableArray(state.actions), _toConsumableArray(action.payload.actions));
    },
    setPromoActionRunning: function setPromoActionRunning(state, action) {
      state.promoActionRunning = action.payload || null;
    },
    setActionCommandLoading: function setActionCommandLoading(state, action) {
      state.actionsLoading = action.payload;
    },
    setLastActionExecuted: function setLastActionExecuted(state, action) {
      state.lastActionExecuted = action.payload;
    },
    deleteActionCommand: function deleteActionCommand(state, action) {
      var uuid = action.payload;
      if (uuid) state.actions = state.actions.filter(function (item) {
        return item.uuid !== action.payload;
      });else state.actions = state.actions.filter(function (action) {
        return !isEqual(action, state.lastActionExecuted);
      });
    },
    clearActionCommands: function clearActionCommands(state) {
      state.actions = [];
      state.promoActionRunning = null;
    }
  }
});
var actions = actionCommandsSlice.actions,
  reducer = actionCommandsSlice.reducer;
var setActionCommand = actions.setActionCommand,
  setActionCommandLoading = actions.setActionCommandLoading,
  clearActionCommands = actions.clearActionCommands,
  deleteActionCommand = actions.deleteActionCommand,
  setLastActionExecuted = actions.setLastActionExecuted,
  setPromoActionRunning = actions.setPromoActionRunning;
export { setActionCommand, setActionCommandLoading, clearActionCommands, deleteActionCommand, setLastActionExecuted, setPromoActionRunning };
export default reducer;